Monet.Format = Monet.Format || {};
Monet.Format.PICKLIST_ICON = (function () {

    function PICKLIST_ICON(value, dataContext, entity, field){

        Monet.Format.Base.apply(this, arguments);

        this.value = value;

        this.toGrid = function () {

            this.value = this.checkIconPaths(value);

            return this;
        };

        this.checkIconPaths = (value) => {
            const iconOptions = App.Objects[entity].iconOptions;
            const iconToCheck = iconOptions && iconOptions.filter( icon => icon.includes(value));
            const checkIconPaths = iconToCheck && iconToCheck.length && iconToCheck[0].split(" ");
            let iconPaths = '';

            if(checkIconPaths && checkIconPaths.length > 1) {
               
                checkIconPaths.splice(0, 1);
                checkIconPaths.forEach( path => {
                    iconPaths += `<span class="${path}"></span>`;
                });   
            }

            return `<div class="picklist-icon ${value}">${iconPaths}</div>`;
        };
    }

    return PICKLIST_ICON;

}());
